// API request state tracking
export type ApiStatus = 'idle' | 'pending' | 'success' | 'rejected';

export interface ApiState {
    status: ApiStatus;
    error: string | null;
}

export const createInitialApiState = (): ApiState => ({
  status: 'idle',
  error: null,
});

export const setApiPending = (state: ApiState) => {
  state.status = 'pending';
  state.error = null;
};

export const setApiSuccess = (state: ApiState) => {
  state.status = 'success';
  state.error = null;
};

export const setApiRejected = (state: ApiState, error: string) => {
  state.status = 'rejected';
  state.error = error;
};

export const setApiIdle = (state: ApiState) => {
  state.status = 'idle';
  state.error = null;
};
